// Oturum düştüğünde (401) uygulama giriş ekranına döner
export const AUTH_EVENT = "rapor:auth-required";

export async function api<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { headers: { "Content-Type": "application/json" }, ...init });
  if (res.status === 401 && url !== "/api/login") window.dispatchEvent(new Event(AUTH_EVENT));
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error ?? `İstek başarısız (${res.status})`);
  }
  return res.status === 204 ? (undefined as T) : res.json();
}

export async function logout() {
  await fetch("/api/logout", { method: "POST" });
  window.dispatchEvent(new Event(AUTH_EVENT));
}
